module.exports = __webpack_public_path__ + "img/headerhz.37c3ea6b.png";